var map = {
	".": 48580,
	"./": 48580,
	"./App.css": 93508,
	"./Board": 90053,
	"./Board.tsx": 90053,
	"./Container": 60539,
	"./Container.tsx": 60539,
	"./Example": 5624,
	"./Example.tsx": 5624,
	"./Fish": 89514,
	"./Fish.test": 23581,
	"./Fish.test.tsx": 23581,
	"./Fish.tsx": 89514,
	"./ItemTypes": 87674,
	"./ItemTypes.ts": 87674,
	"./Menu": 12553,
	"./Menu.tsx": 12553,
	"./MenuFish": 91823,
	"./MenuFish.tsx": 91823,
	"./NumSquareForm": 46115,
	"./NumSquareForm.tsx": 46115,
	"./Overlay": 81109,
	"./Overlay.tsx": 81109,
	"./Popup": 70698,
	"./Popup.tsx": 70698,
	"./Square": 42147,
	"./Square.tsx": 42147,
	"./TankEdit": 57563,
	"./TankEdit.css": 27263,
	"./TankEdit.tsx": 57563,
	"./constants": 14423,
	"./constants.ts": 14423,
	"./data/fish": 80671,
	"./data/fish.json": 80671,
	"./declarations.d": 85690,
	"./declarations.d.ts": 85690,
	"./filterButton": 97100,
	"./filterButton.tsx": 97100,
	"./game": 5719,
	"./game.ts": 5719,
	"./images/anglerfish.png": 82811,
	"./images/bluejellyfish.png": 56158,
	"./images/catfish.png": 65071,
	"./images/crocodile.png": 31722,
	"./images/dolphin.png": 3376,
	"./images/dory.png": 84143,
	"./images/eel.png": 1095,
	"./images/fresh.png": 21213,
	"./images/freshpred.png": 70055,
	"./images/freshprey.png": 52899,
	"./images/gary.png": 57407,
	"./images/killerwhale.png": 81671,
	"./images/koifish.png": 89572,
	"./images/larry.png": 17074,
	"./images/lionfish.png": 99586,
	"./images/mrkrab.png": 21254,
	"./images/mrspuff.png": 89830,
	"./images/pinkjellyfish.png": 72392,
	"./images/pixelFish.png": 58052,
	"./images/predFresh.png": 57900,
	"./images/predSalt.png": 52009,
	"./images/preyFresh.png": 67536,
	"./images/preySalt.png": 55214,
	"./images/salt.png": 92494,
	"./images/saltpred.png": 60261,
	"./images/saltprey1.png": 36666,
	"./images/sardine.png": 55686,
	"./images/seahorse.png": 31198,
	"./images/shark.png": 24251,
	"./images/snail.png": 94244,
	"./images/spongebob.png": 80534,
	"./images/squidward.png": 212,
	"./images/sunfish.png": 58652,
	"./images/swordfish.png": 54163,
	"./images/tank.png": 41052,
	"./images/troutfish.png": 96972,
	"./images/whale.png": 53490,
	"./images/whaleshark.png": 54586,
	"./index": 48580,
	"./index.tsx": 48580,
	"./interfaces": 23829,
	"./interfaces.tsx": 23829,
	"./interfaces/Fish": 9335,
	"./interfaces/Fish.ts": 9335,
	"./interfaces/Tank": 18735,
	"./interfaces/Tank.ts": 18735,
	"./interfaces/fishpics": 11377,
	"./interfaces/fishpics.ts": 11377,
	"./react-app-env.d": 44398,
	"./react-app-env.d.ts": 44398,
	"./reportWebVitals": 58983,
	"./reportWebVitals.ts": 58983,
	"./setupTests": 22887,
	"./setupTests.ts": 22887,
	"./sortButton": 14227,
	"./sortButton.tsx": 14227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40407;